export default "__VITE_ASSET__BzkcoN$G__"